angular.module('directives.dashboard').directive('wgtInfoLatestTransaction', ['DashboardApiService',
        function (DashboardApiService) {
            return {
                templateUrl: 'directives/dashboard/widgets/wgtInfoLatestTransaction/wgtInfoLatestTransaction.tpl.html',
                link: function ($scope, $element) {
                    $scope.isLoaded = false;
                    $scope.hasError = false;
                    $scope.loadWidget = function () {
                        DashboardApiService.getWidgetData($scope.item.name, $scope.item.setting)
                            .then(function (response) {
                                var _data = response.data;
                                $scope.transactionDate = _data[0].transactionDate;
                                $scope.isLoaded = true;
                            }, function (response) {
                                $scope.hasError = true;
                            });
                    };
                    $scope.loadWidget();

                }
            };
        }]
);
